import { isNil } from 'ramda';

import appRoutes from 'src/routes/appRoutes';
import { ExtendedShortUser } from 'src/types/resources/User';
import TalentPersonalInfo from 'src/components/TalentPersonalInfo';
import ExpandedCell from 'src/components/DataTable/components/ExpandedCell';

interface NameTableCellProps {
  talent: ExtendedShortUser;
  isExpanded?: boolean;
  showLocation?: boolean;
  showRevuudApprovedMark?: boolean;
}

const TalentInfoCell: React.FunctionComponent<NameTableCellProps> = props => {
  const { talent, isExpanded, showLocation, showRevuudApprovedMark = false } = props;
  const info = (
    <TalentPersonalInfo
      avatar={talent?.avatarPicture}
      name={talent?.fullName}
      TypographyProps={{ variant: 'button' }}
      isRevuudApproved={showRevuudApprovedMark && talent?.isTalentApprovedByRevuud}
      to={appRoutes.manager.talentPath(talent?.id)}
      city={showLocation && talent?.city}
      state={showLocation && talent?.state}
    />
  );
  return isNil(isExpanded) ? info : <ExpandedCell isExpanded={isExpanded}>{info}</ExpandedCell>;
};

export default TalentInfoCell;
